(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-collection-filters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function relocate() {
      var drawer = document.querySelector('[data-bf-fs-drawer]');
      if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    }
    function lockScroll(on) {
      document.documentElement.style.overflow = on ? 'hidden' : '';
      document.body.style.overflow = on ? 'hidden' : '';
    }
    function openDrawer() {
      var drawer = document.querySelector('[data-bf-fs-drawer]');
      if (!drawer) return;
      drawer.hidden = false;
      // eslint-disable-next-line no-unused-expressions
      drawer.offsetHeight;
      setTimeout(function () { drawer.classList.add('is-open'); }, 16);
      var opener = document.querySelector('[data-bf-fs-open]');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      lockScroll(true);
    }
    function closeDrawer() {
      var drawer = document.querySelector('[data-bf-fs-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      var opener = document.querySelector('[data-bf-fs-open]');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      setTimeout(function () { drawer.hidden = true; }, 320);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', relocate);
    } else {
      relocate();
    }
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-bf-fs-open]')) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest && event.target.closest('[data-bf-fs-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });

    function preservePreviewParams(url) {
      var current = new URL(window.location.href);
      ['preview_theme_id', 'pb', '_fd'].forEach(function (key) {
        var value = current.searchParams.get(key);
        if (value !== null) url.searchParams.set(key, value);
      });
      return url;
    }

    document.addEventListener('click', function (event) {
      var clear = event.target.closest && event.target.closest('.bf-fs-drawer__clear');
      if (!clear || !new URL(window.location.href).searchParams.has('preview_theme_id')) return;
      event.preventDefault();
      window.location.href = preservePreviewParams(new URL(clear.href, window.location.origin)).toString();
    });

    // Form submit: build the URL with only checked / non-empty params, then
    // navigate. This avoids dragging empty inputs into the URL.
    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('[data-bf-fs-form]');
      if (!form) return;
      event.preventDefault();
      var url = preservePreviewParams(new URL(window.location.href.split('?')[0]));
      // Sort
      var sort = form.querySelector('input[name="sort_by"]:checked');
      if (sort && sort.value) url.searchParams.set('sort_by', sort.value);
      // Filters: walk all named inputs except sort_by
      form.querySelectorAll('input[name]').forEach(function (input) {
        if (input.name === 'sort_by') return;
        if (input.type === 'checkbox') {
          if (input.checked) url.searchParams.append(input.name, input.value);
        } else if (input.type === 'number') {
          if (input.value !== '' && input.value !== null) url.searchParams.set(input.name, input.value);
        } else if (input.type === 'radio') {
          if (input.checked && input.value) url.searchParams.set(input.name, input.value);
        }
      });
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bf-chero]').forEach(function (sec) {
      if (sec._bfCheroReady) return;
      sec._bfCheroReady = true;
      var reveals = sec.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-customer-photos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initialize(section) {
      if (section._bfCustomerPhotosReady) return;
      section._bfCustomerPhotosReady = true;

      var track = section.querySelector('[data-bf-customer-photos-track]');
      var previous = section.querySelector('[data-bf-customer-photos-prev]');
      var next = section.querySelector('[data-bf-customer-photos-next]');
      var modal = section.querySelector('[data-bf-customer-photos-modal]');
      var modalImage = section.querySelector('[data-bf-customer-photos-modal-image]');
      var lastTrigger = null;

      function scrollAmount() {
        return Math.max(260, track.clientWidth * 0.82);
      }

      function updateControls() {
        if (!previous || !next) return;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        modalImage.removeAttribute('src');
        modalImage.removeAttribute('srcset');
        document.documentElement.classList.remove('bf-customer-photos-modal-open');
        if (lastTrigger) lastTrigger.focus();
      }

      if (previous) previous.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });

      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        track.scrollBy({
          left: event.key === 'ArrowLeft' ? -scrollAmount() : scrollAmount(),
          behavior: 'smooth'
        });
      });

      section.querySelectorAll('[data-bf-customer-photo-open]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          lastTrigger = trigger;
          modalImage.src = trigger.dataset.photoSrc;
          modalImage.srcset = trigger.dataset.photoSrcset;
          modalImage.alt = trigger.dataset.photoAlt || '';
          modal.hidden = false;
          document.documentElement.classList.add('bf-customer-photos-modal-open');
          section.querySelector('[data-bf-customer-photos-close]:not(.bf-customer-photos__backdrop)').focus();
        });
      });

      section.querySelectorAll('[data-bf-customer-photos-close]').forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (!modal || modal.hidden) return;
        if (event.key === 'Escape') {
          closeModal();
          return;
        }
        if (event.key === 'Tab') {
          event.preventDefault();
          section.querySelector('[data-bf-customer-photos-close]:not(.bf-customer-photos__backdrop)').focus();
        }
      });

      updateControls();
      window.addEventListener('resize', updateControls, { passive: true });
    }

    document.querySelectorAll('[data-bf-customer-photos]').forEach(initialize);
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-bf-customer-photos]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-details-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bf-dg]').forEach(function (section) {
      if (section._bfDgReady) return;
      section._bfDgReady = true;
      var reveals = section.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-dimensions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-bf-dim]');
    sections.forEach(function (section) {
      if (section._bfDimReady) return;
      section._bfDimReady = true;
      var reveals = section.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-lifestyle-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-bf-lif]');
    sections.forEach(function (section) {
      if (section._bfLifReady) return;
      section._bfLifReady = true;
      var reveals = section.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-bf-tabs]');
    sections.forEach(function (section) {
      if (section._bfTabsReady) return;
      section._bfTabsReady = true;

      /* ---- Scroll reveal ---- */
      var reveals = section.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }

      /* ---- Tab switching ---- */
      var navitems = section.querySelectorAll('.bf-tabs__navitem');
      var panels = section.querySelectorAll('.bf-tabs__panel');
      var nav = section.querySelector('.bf-tabs__nav');

      function revealActiveNavItem(item) {
        if (!nav || nav.scrollWidth <= nav.clientWidth) return;
        window.requestAnimationFrame(function () {
          var maxLeft = nav.scrollWidth - nav.clientWidth;
          var targetLeft = item.offsetLeft - ((nav.clientWidth - item.offsetWidth) / 2);
          nav.scrollTo({
            left: Math.max(0, Math.min(maxLeft, targetLeft)),
            behavior: 'smooth'
          });
        });
      }

      function syncSinkStickyOffset() {
        var navwrap = section.querySelector('.bf-tabs__navwrap');
        if (!navwrap) return;
        var height = Math.ceil(navwrap.getBoundingClientRect().height) || 72;
        section.style.setProperty('--bf-tabs-nav-offset', height + 'px');
      }

      syncSinkStickyOffset();
      window.addEventListener('resize', syncSinkStickyOffset, { passive: true });

      var phoneQuery = window.matchMedia('(max-width: 749px)');
      function stickyHeaderOffset() {
        var navwrap = section.querySelector('.bf-tabs__navwrap');
        var top = navwrap ? parseFloat(window.getComputedStyle(navwrap).top) : NaN;
        return Number.isFinite(top) ? top : 0;
      }
      function isPhone() { return phoneQuery.matches; }

      function setPanelOpen(id, open) {
        var panel = section.querySelector('.bf-tabs__panel[data-bf-panel="' + id + '"]');
        var head = section.querySelector('.bf-tabs__acc[data-bf-acc="' + id + '"]');
        if (panel) panel.classList.toggle('is-open', open);
        if (head) {
          head.classList.toggle('is-open', open);
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        if (open && id === 'tour3d') resumeTour();
      }

      function resumeTour() {
        syncSinkStickyOffset();
        window.requestAnimationFrame(function () {
          window.dispatchEvent(new Event('resize'));
          if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.resume === 'function') {
            window.BadeloftConfigurator.resume();
          }
          if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.setHotspotsVisible === 'function') {
            window.BadeloftConfigurator.setHotspotsVisible(true);
          }
        });
      }

      section.addEventListener('click', function (e) {
        var head = e.target.closest('.bf-tabs__acc');
        if (!head) return;
        var id = head.dataset.bfAcc;
        var open = !head.classList.contains('is-open');
        setPanelOpen(id, open);
        if (open) {
          window.requestAnimationFrame(function () {
            var top = head.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset() - 8;
            if (head.getBoundingClientRect().top < 0) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          });
        }
      });

      function activateTab(item, moveFocus) {
        if (!item) return;
        var id = item.dataset.bfTab;
        if (isPhone()) setPanelOpen(id, true);
        navitems.forEach(function (n) {
          var on = n === item;
          n.classList.toggle('is-active', on);
          n.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.bfPanel === id);
        });
        revealActiveNavItem(item);
        if (moveFocus) item.focus();
        if (id === 'tour3d' && !isPhone()) resumeTour();
      }

      if (nav) {
        nav.addEventListener('click', function (e) {
          var item = e.target.closest('.bf-tabs__navitem');
          if (!item) return;
          activateTab(item, false);
        });
        nav.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
          var items = Array.prototype.slice.call(navitems);
          var current = items.indexOf(document.activeElement);
          if (current < 0) return;
          e.preventDefault();
          var next = current;
          if (e.key === 'ArrowRight') next = (current + 1) % items.length;
          if (e.key === 'ArrowLeft') next = (current - 1 + items.length) % items.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = items.length - 1;
          activateTab(items[next], true);
        });
      }

      function scrollPanelIntoView(panel) {
        window.requestAnimationFrame(function () {
          if (isPhone()) {
            var head = section.querySelector('.bf-tabs__acc[data-bf-acc="' + panel.dataset.bfPanel + '"]');
            var target = (head || panel).getBoundingClientRect().top + window.scrollY - stickyHeaderOffset() - 8;
            window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
            return;
          }
          var navwrap = section.querySelector('.bf-tabs__navwrap');
          var stickyTop = navwrap ? parseFloat(window.getComputedStyle(navwrap).top) : 0;
          var offset = (Number.isFinite(stickyTop) ? stickyTop : 0) + (navwrap ? navwrap.offsetHeight : 0) + 16;
          var targetTop = panel.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: 'smooth'
          });
        });
      }

      /* Rest the sticky tab bar exactly on its pinned position so the active panel
         starts below it. Measured from the nav bar's natural layout offset
         (offsetTop ignores sticky painting) instead of the panel box: the 3D
         configurator canvas resizes after the scroll begins, and a panel-based
         target goes stale mid-animation and leaves the panel's own toolbar
         hidden behind the nav. */
      function scrollTabsIntoView() {
        if (isPhone()) {   // Eric 8 Oct: the tab bar is display:none on phones, so its offsetTop chain is 0 and this scrolled to the page top; go to the open accordion head instead
          var openHead = section.querySelector('.bf-tabs__acc[data-bf-acc="tour3d"]') || section.querySelector('.bf-tabs__acc.is-open');   // the description accordion is open by default too, so target the tour head first (Jessie 9 Oct)
          if (openHead) {
            window.setTimeout(function () {   // after the accordion panel has opened and pushed the layout
              var t = openHead.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset() - 8;
              window.scrollTo({ top: Math.max(0, t), behavior: 'smooth' });
            }, 60);
            return;
          }
        }
        var navwrap = section.querySelector('.bf-tabs__navwrap');
        if (!navwrap) return;
        var stickyTop = parseFloat(window.getComputedStyle(navwrap).top);
        if (!Number.isFinite(stickyTop)) stickyTop = 0;
        var naturalTop = 0;
        for (var node = navwrap; node; node = node.offsetParent) naturalTop += node.offsetTop;
        window.scrollTo({
          top: Math.max(0, naturalTop - stickyTop),
          behavior: 'smooth'
        });
      }
      section._bfScrollTabsIntoView = scrollTabsIntoView;

      function openDimensions(shouldScroll) {
        var item = section.querySelector('[data-bf-tab="dimensions"]');
        var panel = section.querySelector('#bf-dimensions');
        if (!item || !panel) return false;
        activateTab(item, false);
        if (shouldScroll) scrollPanelIntoView(panel);
        return true;
      }

      var deepLinks = { '#bf-dimensions': 'dimensions', '#bf-downloads': 'downloads' };
      if (!document.documentElement._bfDimensionsLinkReady) {
        document.documentElement._bfDimensionsLinkReady = true;
        document.addEventListener('click', function (e) {
          var link = e.target.closest('a[href="#bf-dimensions"], a[href="#bf-downloads"]');
          if (!link) return;
          var hash = link.getAttribute('href');
          var tabId = deepLinks[hash];
          var tabsSection = document.querySelector('[data-bf-tabs]');
          var tab = tabsSection && tabsSection.querySelector('[data-bf-tab="' + tabId + '"]');
          var panel = tabsSection && tabsSection.querySelector('.bf-tabs__panel[data-bf-panel="' + tabId + '"]');
          if (!tab || !panel) return;
          e.preventDefault();
          tab.click();
          if (window.history && window.history.pushState) window.history.pushState(null, '', hash);
          scrollPanelIntoView(panel);
        });
      }

      if (window.location.hash === '#bf-dimensions') {
        window.setTimeout(function () { openDimensions(true); }, 0);
      }
      if (window.location.hash === '#bf-downloads') {
        window.setTimeout(function () {
          var dlTab = section.querySelector('[data-bf-tab="downloads"]');
          var dlPanel = section.querySelector('#bf-downloads');
          if (dlTab && dlPanel) { activateTab(dlTab, false); scrollPanelIntoView(dlPanel); }
        }, 0);
      }

      /* ---- Enlarged dimension drawing ---- */
      var dimModal = section.querySelector('[data-bf-dim-modal]');
      var dimOpener = null;
      if (dimModal) {
        function closeDimensionModal(restoreFocus) {
          dimModal.hidden = true;
          document.documentElement.style.overflow = '';
          if (restoreFocus && dimOpener) dimOpener.focus();
        }

        section.addEventListener('click', function (e) {
          var opener = e.target.closest('[data-bf-dim-open]');
          if (opener) {
            var largeImage = dimModal.querySelector('[data-bf-dim-modal-img]');
            var closeButton = dimModal.querySelector('.bf-tabs__dimclose');
            dimOpener = opener;
            if (largeImage) {
              largeImage.src = opener.getAttribute('data-bf-dim-full') || '';
              largeImage.alt = opener.getAttribute('data-bf-dim-alt') || '';
            }
            dimModal.hidden = false;
            document.documentElement.style.overflow = 'hidden';
            if (closeButton) closeButton.focus();
            return;
          }
          if (e.target.closest('[data-bf-dim-close]')) closeDimensionModal(true);
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !dimModal.hidden) closeDimensionModal(true);
        });
      }

      /* ---- Feature popups (in description) ---- */
      var featModal = section.querySelector('[data-bf-feat-modal]');
      if (featModal) {
        section.addEventListener('click', function (e) {
          var t = e.target.closest('[data-bf-feat]');
          if (t) {
            var img = featModal.querySelector('[data-bf-feat-modal-img]');
            var ti = featModal.querySelector('[data-bf-feat-modal-title]');
            var tx = featModal.querySelector('[data-bf-feat-modal-text]');
            var vid = featModal.querySelector('[data-bf-feat-modal-video]');
            var featVid = t.getAttribute('data-bf-feat-video');
            if (vid) {
              if (featVid) {
                if (vid.getAttribute('src') !== featVid) vid.src = featVid;
                vid.hidden = false;
                var pv = vid.play(); if (pv && pv.catch) pv.catch(function () {});
              } else { vid.pause(); vid.removeAttribute('src'); vid.load(); vid.hidden = true; }
            }
            if (img) {
              /* Badeloft 2026-08-30: a feature with no image used to set src="null" and render a broken image. */
              var featSrc = t.getAttribute('data-bf-feat-img');
              if (featSrc && !featVid) { img.src = featSrc; img.hidden = false; }
              else { img.removeAttribute('src'); img.hidden = true; }
              img.alt = t.getAttribute('data-bf-feat-title') || '';
            }
            if (ti) ti.textContent = t.getAttribute('data-bf-feat-title') || '';
            if (tx) tx.textContent = t.getAttribute('data-bf-feat-text') || '';
            featModal.hidden = false;
            document.documentElement.style.overflow = 'hidden';
            return;
          }
          if (e.target.closest('[data-bf-feat-close]')) {
            var xv = featModal.querySelector('[data-bf-feat-modal-video]');
            if (xv) { xv.pause(); try { xv.currentTime = 0; } catch (err) {} }
            featModal.hidden = true;
            document.documentElement.style.overflow = '';
          }
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !featModal.hidden) {
            featModal.hidden = true;
            document.documentElement.style.overflow = '';
          }
        });
      }

      /* ---- Multi-file downloads ---- */
      var dl = section.querySelector('[data-bf-downloads]');
      if (!dl) return;
      var selectAll = dl.querySelector('[data-bf-select-all]');
      var files = dl.querySelectorAll('[data-bf-file]');
      var btn = dl.querySelector('[data-bf-download-btn]');
      var btnLabel = dl.querySelector('[data-bf-btn-label]');
      var countEl = dl.querySelector('[data-bf-download-count]');
      var status = dl.querySelector('[data-bf-status]');
      var originalLabel = btnLabel ? btnLabel.innerHTML : '';

      function updateCount() {
        var n = dl.querySelectorAll('[data-bf-file]:checked').length;
        if (countEl) countEl.textContent = n;
        if (btn) btn.disabled = n === 0;
        if (selectAll) {
          selectAll.checked = n === files.length;
          selectAll.indeterminate = n > 0 && n < files.length;
        }
      }
      if (selectAll) {
        selectAll.addEventListener('change', function () {
          files.forEach(function (f) { f.checked = selectAll.checked; });
          updateCount();
        });
      }
      files.forEach(function (f) { f.addEventListener('change', updateCount); });

      function downloadFile(url, filename) {
        return fetch(url, { mode: 'cors', credentials: 'omit' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.blob();
          })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 1000);
            return { ok: true };
          })
          .catch(function (e) { return { ok: false, error: e.message }; });
      }
      function showStatus(text, isError) {
        if (!status) return;
        status.hidden = false;
        status.textContent = text;
        status.classList.toggle('bf-tabs__dl-status--error', !!isError);
      }
      if (btn) {
        btn.addEventListener('click', function () {
          var selected = Array.prototype.slice.call(dl.querySelectorAll('[data-bf-file]:checked'));
          if (selected.length === 0) return;
          btn.disabled = true;
          var succeeded = 0;
          var failed = [];
          var chain = Promise.resolve();
          selected.forEach(function (cb, i) {
            chain = chain.then(function () {
              if (btnLabel) btnLabel.textContent = 'Downloading ' + (i + 1) + ' of ' + selected.length + '...';
              return downloadFile(cb.dataset.bfUrl, cb.dataset.bfName).then(function (r) {
                if (r.ok) { succeeded++; } else { failed.push(cb.dataset.bfName); }
                if (i < selected.length - 1) return new Promise(function (r2) { setTimeout(r2, 200); });
              });
            });
          });
          chain.then(function () {
            if (btnLabel) btnLabel.innerHTML = originalLabel;
            btn.disabled = false;
            if (failed.length === 0) {
              showStatus('Downloaded ' + succeeded + ' file' + (succeeded === 1 ? '' : 's') + '.', false);
            } else {
              showStatus('Downloaded ' + succeeded + ' of ' + selected.length + '. ' + failed.length + ' failed — try the individual links.', true);
            }
            setTimeout(function () { if (status) status.hidden = true; }, 6000);
          });
        });
      }
      updateCount();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bf-rel]').forEach(function (section) {
      if (section._bfRelReady) return;
      section._bfRelReady = true;
      var reveals = section.querySelectorAll('[data-bf-reveal]');
      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
        reveals.forEach(function (el) { obs.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-top-sellers"]) return;
  try {
    
  (function () {
    function load(row) {
      if (row.dataset.state !== 'shell' || row.dataset.bfTsLoaded) return;
      row.dataset.bfTsLoaded = 'true';

      var url = new URL(window.location.pathname, window.location.origin);
      // Keep theme-preview context so the row previews from the same theme.
      ['preview_theme_id', 'pb', '_fd', 'view'].forEach(function (key) {
        var value = new URL(window.location.href).searchParams.get(key);
        if (value !== null) url.searchParams.set(key, value);
      });
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('section_id', row.dataset.sectionId);

      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('bf-top-sellers: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-bf-ts-list] > .product-grid__item');
          if (!cards.length) throw new Error('bf-top-sellers: no cards');
          var list = row.querySelector('[data-bf-ts-list]');
          var fragment = document.createDocumentFragment();
          cards.forEach(function (card) { fragment.appendChild(document.importNode(card, true)); });
          list.replaceChildren(fragment);
          row.dataset.state = 'ready';
        })
        .catch(function () {
          row.classList.add('is-empty');
        });
    }

    function init() {
      document.querySelectorAll('[data-bf-ts]').forEach(load);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf_gallery_grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initialize(gallery) {
      if (gallery.dataset.galleryReady === 'true') return;
      gallery.dataset.galleryReady = 'true';
      var filters = gallery.querySelectorAll('[data-gallery-filter]');
      var items = gallery.querySelectorAll('[data-gallery-item]');
      var empty = gallery.querySelector('[data-gallery-empty]');
      var dialog = gallery.querySelector('[data-gallery-dialog]');
      var dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      var close = gallery.querySelector('[data-gallery-close]');
      var lastTrigger = null;

      var modelButtons = gallery.querySelectorAll('[data-gallery-model-filter]');
      var activeCategory = 'all';
      var activeModel = null;

      function apply() {
        var visible = 0;
        items.forEach(function (item) {
          var okCat = activeCategory === 'all' || item.dataset.galleryCategory === activeCategory;
          var okModel = !activeModel || item.dataset.galleryModel === activeModel;
          var show = okCat && okModel;
          item.hidden = !show;
          if (show) visible += 1;
        });
        modelButtons.forEach(function (button) {
          button.hidden = activeCategory !== 'all' && button.dataset.galleryModelCat !== activeCategory;
          button.setAttribute('aria-pressed', String(button.dataset.galleryModelFilter === activeModel));
        });
        filters.forEach(function (button) {
          button.setAttribute('aria-pressed', String(button.dataset.galleryFilter === activeCategory));
        });
        empty.hidden = visible !== 0;
      }

      filters.forEach(function (filter) {
        filter.addEventListener('click', function () {
          activeCategory = filter.dataset.galleryFilter;
          activeModel = null;
          apply();
        });
      });

      modelButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var code = button.dataset.galleryModelFilter;
          activeModel = activeModel === code ? null : code;
          apply();
        });
      });

      apply();

      gallery.querySelectorAll('.bf-gallery-grid__open').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          if (!trigger.dataset.gallerySrc) return;
          lastTrigger = trigger;
          dialogImage.src = trigger.dataset.gallerySrc;
          dialogImage.alt = trigger.dataset.galleryAlt || '';
          dialog.showModal();
          close.focus();
        });
      });

      function closeDialog() {
        if (!dialog.open) return;
        dialog.close();
        dialogImage.removeAttribute('src');
        if (lastTrigger) lastTrigger.focus();
      }

      close.addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) { if (event.target === dialog) closeDialog(); });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); closeDialog(); });
    }

    document.querySelectorAll('[data-bf-gallery]').forEach(initialize);
    document.addEventListener('shopify:section:load', function (event) {
      var gallery = event.target.querySelector('[data-bf-gallery]');
      if (gallery) initialize(gallery);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf_journal_article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slugify(text, used) {
      var base = (text || '')
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60) || 'section';
      var slug = base;
      var i = 2;
      while (used[slug]) { slug = base + '-' + i; i += 1; }
      used[slug] = true;
      return slug;
    }

    function buildToc(root) {
      var toc = root.querySelector('[data-article-toc]');
      var list = root.querySelector('[data-article-toc-list]');
      var body = root.querySelector('[data-article-body]');
      if (!toc || !list || !body) return;

      var headings = body.querySelectorAll('h2, h3');
      var used = {};
      var count = 0;

      headings.forEach(function (heading) {
        var raw = (heading.textContent || '').trim();
        if (!raw) return;
        // Some posts number their own headings ("1. Why ..."). Strip that so the
        // list counter does not render a second number ("1. 1. Why ...").
        var label = raw.replace(/^\d+\s*[.)]\s+/, '') || raw;
        if (!heading.id) heading.id = slugify(label, used);
        var item = document.createElement('li');
        item.setAttribute('data-depth', heading.tagName === 'H3' ? '3' : '2');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = label;
        item.appendChild(link);
        list.appendChild(item);
        count += 1;
      });

      if (count < 2) { toc.hidden = true; return; }
      if (window.matchMedia('(max-width: 640px)').matches) toc.open = false;
    }

    function init() {
      document.querySelectorAll('.bf-journal-article').forEach(buildToc);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Special Order is made up of whichever colour products are actually
  // special order, so a family can cross an infinite-scroll page boundary or
  // move between pages after sorting. Keep the earliest rendered card for each
  // family and hide later duplicates while preserving their page markers.
  if (window.location.pathname === '/collections/special-order') {
    let specialOrderDedupeFrame;
    const dedupeSpecialOrderCards = () => {
      const seenFamilies = new Set();
      document
        .querySelectorAll('results-list [ref="grid"] > [data-bf-colour-family]')
        .forEach((card) => {
          const family = card.dataset.bfColourFamily;
          const duplicate = Boolean(family && seenFamilies.has(family));
          card.hidden = duplicate;
          if (family && !duplicate) seenFamilies.add(family);
        });
    };
    const scheduleSpecialOrderDedupe = () => {
      cancelAnimationFrame(specialOrderDedupeFrame);
      specialOrderDedupeFrame = requestAnimationFrame(dedupeSpecialOrderCards);
    };

    scheduleSpecialOrderDedupe();
    new MutationObserver(scheduleSpecialOrderDedupe).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  } catch(e) { console.error(e); }
})();
})();
